
const LockPage = {
    init() {
        this.initializeDays();
        this.initializeYears();
        this.setupEventListeners();
        this.checkCookie();
    },

    initializeDays() {
        const daySelect = document.getElementById('birthDay');
        for (let i = 1; i <= 31; i++) {
            const option = document.createElement('option');
            option.value = i;
            option.text = i;
            daySelect.appendChild(option);
        }
    },

    initializeYears() {
        const element = document.querySelector(".lock_holder");
        const dateType = element.getAttribute("data-dateType");
        const yearSelect = document.getElementById('birthYear');

        if (dateType === "jalali") {

            for (let year = 1405; year >= 1300; year--) {
                const option = document.createElement('option');
                option.value = year;
                option.text = year;
                yearSelect.appendChild(option);
            }
        } else {

            const currentYear = new Date().getFullYear();
            for (let year = currentYear; year >= 1950; year--) {
                const option = document.createElement('option');
                option.value = year;
                option.text = year;
                yearSelect.appendChild(option);
            }
        }
    },

    showError() {
        const errorMessage = document.getElementById('errorMessage');
        errorMessage.classList.add('visible');
        setTimeout(() => {
            errorMessage.classList.remove('visible');
        }, 3000);
    },

    showWrong() {
        const errorMessage = document.getElementById('errorMessage2');
        errorMessage.classList.add('visible');
        setTimeout(() => {
            errorMessage.classList.remove('visible');
        }, 3000);
    },

    verifyAndShow() {
        const day = document.getElementById('birthDay').value;
        const year = document.getElementById('birthYear').value;
        const element = document.querySelector(".lock_holder");
        const encryptedData = element.getAttribute("data-marketingUTM");
        const urlData = element.getAttribute("data-url");
        const decodedData = atob(encryptedData);
        const [yearOriginal, dayOriginal] = decodedData.split("-");

        if (!day || !year) {
            this.showError();
            return;
        }

        if (day !== dayOriginal || year !== yearOriginal) {
            this.showWrong();
            return;
        }

        document.getElementById('securityOverlay').style.display = 'none';
        document.getElementById('reportContent').style.display = 'block';

        const cookie_name = "lockpage-" + yearOriginal + "@" + dayOriginal;
        this.setSecureCookie(cookie_name, "true", 1, urlData);
    },

    setSecureCookie(name, value, days, url) {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        const cookieValue = `${url}`;
        const cookieString = `${name}=${cookieValue}; expires=${expires.toUTCString()}; path=/; Secure; SameSite=Strict`;
        document.cookie = cookieString;
    },

    checkCookie() {
        const element = document.querySelector(".lock_holder");
        const cookies = document.cookie.split(';');
        const encryptedData = element.getAttribute("data-marketingUTM");
        const decodedData = atob(encryptedData);
        const [year, day] = decodedData.split("-");
        let cookieMatched = false;
        const currentURL = window.location.href;

        cookies.forEach(cookie => {
            const cookieName = cookie.trim().split('=')[0];
            if (cookieName.startsWith("lockpage-")) {
                const cookieYearDay = cookieName.split('-')[1];
                const [cookieYear, cookieDay] = cookieYearDay.split('@');
                const cookieValue = cookie.trim().split('=')[2];
                const currentURLUp = currentURL.trim().split('=')[1];

                const check_url = currentURLUp === cookieValue || currentURLUp === cookieValue + "#open-modal"
                if (cookieYear === year && cookieDay === day && check_url ) {
                    cookieMatched = true;
                }
            }
        });

        if (!cookieMatched) {
            element.style.display = "block";
        }
    },

    setupEventListeners() {

        window.verifyAndShow = this.verifyAndShow.bind(this);

        const verifyButton = document.querySelector('#verifyButton');
        if (verifyButton) {
            verifyButton.addEventListener('click', this.verifyAndShow.bind(this));
        }
    }
};


document.addEventListener('DOMContentLoaded', () => {
    LockPage.init();
});


export default LockPage;